import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { FormGroup } from '@angular/forms';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { ParticulierBancaire } from 'src/app/api/model/particulier-bancaire.model';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { FormulaireCoordonneesBancaires } from 'src/app/models/formulaire/formulaire-coordonnees-bancaires.model';
import { FormulaireBancaireService } from 'src/app/services/formulaire-bancaire/formulaire-bancaire.service';
import { FormulaireBancaireBuilder } from 'src/app/models/formulaire/formulaire-bancaire-builder.model';
import { Anys } from 'src/app/util/anys';
import { AdressePhysiqueBancaire } from 'src/app/api/model/adresse-physique-bancaire.model';
import { AdressePostdateeBancaire } from 'src/app/api/model/adresse-postdatee-bancaire.model';
import { AccessibiliteService } from 'src/app/services/accessibilite.service';
import { TelephoneTypeLieuEnum } from 'src/app/models/telephone-typelieu.enum';
import { TelephoneTypeEnum } from 'src/app/models/telephone-type.enum';
import { DsdForm } from '@dsd/library-angular';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../../models/cybermetrie/cybermetrie.enum';

export enum TelephoneCible {
  TRAVAIL = 'telephoneTravail',
  SECONDAIRE = 'telephoneSecondaire',
}

@Component({
  selector: 'app-modification-coordonnees',
  templateUrl: './modification-coordonnees.component.html',
  standalone: false,
})
export class ModificationCoordonneesComponent implements OnInit, AfterViewInit {
  @ViewChild(DsdForm) dsdForm: DsdForm;
  coordonneesMembre?: ParticulierBancaire;
  adresseCourante: AdressePhysiqueBancaire;
  adressePostDatee: AdressePostdateeBancaire;
  formBancaire: FormGroup<FormulaireCoordonneesBancaires>;
  isAppMobile: boolean;
  codeErreur: string = '';
  telephoneCible: TelephoneCible;
  showModaleSupprimerTelephone: boolean = false;

  constructor(
    private readonly globalStoreService: GlobalStoreService,
    private readonly navigationService: NavigationService,
    private readonly gabaritService: GabaritService,
    private readonly gestionTitreService: GestionTitreService,
    private readonly formulaireBancaireService: FormulaireBancaireService,
    private readonly accessibiliteService: AccessibiliteService,
    private readonly cybermetrieCoordonneesService: CybermetrieCoordonneesService
  ) {}

  ngOnInit(): void {
    this.gestionTitreService.addTitreOnglet('caad.titreOnglet.page-modification');
    this.isAppMobile = this.gabaritService.isAppMobile();

    if (Anys.notNullOrUndef(this.formulaireBancaireService.getForm())) {
      this.formBancaire = this.formulaireBancaireService.getForm();
      this.initAdresseCourante();
    } else {
      this.globalStoreService.getCoordonneesMembre$().subscribe((membre) => {
        if (membre) {
          this.coordonneesMembre = membre;
          this.formBancaire = FormulaireBancaireBuilder.build();
          this.adresseCourante = membre.adresseCourante;
          this.adressePostDatee = membre.adressePostdatee;
          this.initTelephonePrincipal(membre);
          this.initTelephoneSecondaire(membre);
          this.initTelephoneTravail(membre);
          const courriel = membre.courriel?.adresseCourriel || '';
          this.formBancaire.patchValue({ courriel });
          if (courriel && this.formBancaire.controls.courriel.invalid) {
            this.formBancaire.patchValue({ courriel: '' });
          }
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.cybermetrieCoordonneesService.debuterTransactionCoordonneesBancaire();
    this.accessibiliteService.setFocus('#titreModification');
  }

  clickAjouterTelephoneSecondaire(): void {
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(
      CybermetrieEnum.LABEL_BANCAIRE_AJOUTER_TELEPHONE_SECONDIRE
    );
    this.ajouterTelephoneSecondaire();
  }

  ajouterTelephoneSecondaire(): void {
    this.formBancaire.addControl('telephoneSecondaire', FormulaireBancaireBuilder.buildTelephone());
  }

  clickAjouterTelephoneTravail(): void {
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(
      CybermetrieEnum.LABEL_BANCAIRE_AJOUTER_TELEPHONE_TRAVAIL
    );
    this.ajouterTelephoneTravail();
  }

  ajouterTelephoneTravail(): void {
    this.formBancaire.addControl('telephoneTravail', FormulaireBancaireBuilder.buildTelephoneTravail());
  }

  supprimerTelephoneSecondaire(): void {
    this.telephoneCible = TelephoneCible.SECONDAIRE;
    this.showModaleSupprimerTelephone = true;
  }

  supprimerTelephoneTravail(): void {
    this.telephoneCible = TelephoneCible.TRAVAIL;
    this.showModaleSupprimerTelephone = true;
  }

  valider(): void {
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(CybermetrieEnum.LABEL_BANCAIRE_VALIDER);
  }

  handleConfirmSuppressionTelephone(): void {
    if (this.telephoneCible === TelephoneCible.SECONDAIRE) {
      this.formBancaire.removeControl('telephoneSecondaire');
      this.accessibiliteService.setFocus('#boutonAjoutTelephoneSecondaire');
    } else if (this.telephoneCible === TelephoneCible.TRAVAIL) {
      this.formBancaire.removeControl('telephoneTravail');
      this.accessibiliteService.setFocus('#boutonAjoutTelephoneTravail');
    }
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(CybermetrieEnum.LABEL_BANCAIRE_SUPPRIMER_TELEPHONE);
    this.closeModal();
  }

  closeModal(): void {
    this.showModaleSupprimerTelephone = false;
    this.telephoneCible = null;
  }

  annulerModification(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
    this.globalStoreService.saveDeclancherModale(CybermetrieEnum.ACTION_DEBUTE);
  }

  async naviguerVersPageValidation(): Promise<void> {
    const utiliserMemeAdresse = this.formBancaire.get('utiliserMemeAdresse')?.value === true;
    const errors = await this.dsdForm.validate();
    if (errors.length === 0 && (this.formBancaire.valid || utiliserMemeAdresse)) {
      this.formulaireBancaireService.setForm(this.formBancaire);
      this.navigationService.naviguerVersValiderCoordonnees();
    } else {
      this.cybermetrieCoordonneesService.transactionCoordonneesBancaire(CybermetrieEnum.ACTION_ERREUR_UTILISATEUR);
    }
  }

  public initAdresseCourante(): void {
    this.globalStoreService.getCoordonneesMembre$().subscribe((membre) => {
      this.adresseCourante = membre?.adresseCourante;
    });
  }

  public initTelephonePrincipal(membre: ParticulierBancaire): void {
    const telephonePrincipal = membre?.telephones?.find((t) => t.typeLieu === TelephoneTypeLieuEnum.PRINCIPALE);
    if (telephonePrincipal) {
      this.formBancaire.patchValue({
        telephonePrincipal: {
          telephone: telephonePrincipal.numeroTelephone,
          poste: telephonePrincipal.numeroPoste,
          typeTelephone: telephonePrincipal.typeAppareil as TelephoneTypeEnum,
        },
      });
    }
  }

  public initTelephoneSecondaire(membre: ParticulierBancaire): void {
    const telephoneSecondaire = membre?.telephones
      ?.filter((t) => t.typeLieu === TelephoneTypeLieuEnum.SECONDAIRE)
      .sort((a, b) => (a.empreinte < b.empreinte ? 1 : -1))[0];
    if (telephoneSecondaire) {
      this.ajouterTelephoneSecondaire();
      this.formBancaire.patchValue({
        telephoneSecondaire: {
          telephone: telephoneSecondaire.numeroTelephone,
          poste: telephoneSecondaire.numeroPoste,
          typeTelephone: telephoneSecondaire.typeAppareil as TelephoneTypeEnum,
        },
      });
    }
  }

  public initTelephoneTravail(membre: ParticulierBancaire): void {
    const telephoneTravail = membre?.telephones?.find((t) => t.typeLieu === TelephoneTypeLieuEnum.TRAVAIL);
    if (telephoneTravail) {
      this.ajouterTelephoneTravail();
      this.formBancaire.patchValue({
        telephoneTravail: {
          telephone: telephoneTravail.numeroTelephone,
          poste: telephoneTravail.numeroPoste,
          typeTelephone: telephoneTravail.typeAppareil as TelephoneTypeEnum,
        },
      });
    }
  }
}
